module.exports = __webpack_public_path__ + "img/slide01_sp.1fe1ebde.png";